export default () => ({
    video: null,

    init() {
        this.video = this.$el.querySelector('video')

        if (!this.video) {
            return
        }

        this.observer = !!window.IntersectionObserver
            ? new IntersectionObserver(
                  (entries, observer) => {
                      for (const entry of entries) {
                          if (entry.intersectionRatio > 0) {
                              this.onIntersecting(entry.target)
                              observer.unobserve(entry.target)
                          }
                      }
                  },
                  {
                      rootMargin: '0% 0% -30% 0%',
                      threshold: 0,
                  }
              )
            : null

        if (this.observer) {
            this.observer.observe(this.video)
        } else {
            this.onIntersecting(this.video)
        }
    },

    onIntersecting(target) {
        target?.play()
    },
})
